module.exports = __webpack_public_path__ + "img/speaker-filled.3420bca8.png";